import Product from './ui/main/Product';
import { PRICE } from './constants/modes';
import { productsSegment } from './model/state-manager/productsSegment';
import useGetProductsAndClear from './model/hooks/useGetProductsAndClear';

export default Product;

export { PRICE, productsSegment, useGetProductsAndClear };
